import React from 'react';
import { diceTypes } from './EoTResult'
import { removeOppositeOrAddVal, getAllRolledFaces } from '../resultHelpers';

var summarizeRoll = (result) => {

  var allRolledFaces = getAllRolledFaces(result, diceTypes);

  var successFail = [],
    advantageThreat = [],
    triumpDispair = [],
    blackWhite = [];

  allRolledFaces.forEach(face => {
    switch (face) {
      case 'S': removeOppositeOrAddVal(successFail, 'F', face); break;
      case 'F': removeOppositeOrAddVal(successFail, 'S', face); break;

      case 'A': removeOppositeOrAddVal(advantageThreat, 'T', face); break;
      case 'T': removeOppositeOrAddVal(advantageThreat, 'A', face); break;

      // Triumph / Despair don't cancel out... but the success / fail
      case 'D':
        triumpDispair.push('D');
        removeOppositeOrAddVal(successFail, 'S', 'F');
        break;
      case 'R':
        triumpDispair.push('R');
        removeOppositeOrAddVal(successFail, 'F', 'S');
        break;

      // Force dice don't cancel each other out
      case 'B':
      case 'W': blackWhite.push(face); break;

      default: break; // Skip faces we don't know
    }
  })

  return {
    successFail,
    advantageThreat,
    triumpDispair,
    blackWhite
  }
}

var EoTResultSummary = ({ result }) => {
  var summary = summarizeRoll(result);

  var faceMap = {
    S: 'success', A: 'advantage', R: 'triumph', B: 'black',
    F: 'fail', T: 'threat', D: 'despair', W: 'white',
  }

  var fKey = 0;
  var faceImgFn = face => <img height="21" key={fKey++} alt={faceMap[face]} className="summaryDiceFace" src={`/diceImages/eot/summaryFaces/${faceMap[face]}.png`} />

  return (
    <div>
      <span title={summary.triumpDispair.length}>{summary.triumpDispair.map(faceImgFn)}</span>
      <span title={summary.successFail.length}>{summary.successFail.map(faceImgFn)}</span>
      <span title={summary.advantageThreat.length}>{summary.advantageThreat.map(faceImgFn)}</span>
      <span title={summary.blackWhite.length}>{summary.blackWhite.map(faceImgFn)}</span>
    </div>
  )
}

export { summarizeRoll };
export default EoTResultSummary;


// WEBPACK FOOTER //
// ./src/RollResults/EoT/EoTResultSummary.js